import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {IGetBookingsCommonResponse} from "libraries/service/resources/booking/interfaces/IGetBookings";
import {ILabels} from "../../interfaces/ILabels";
import {Yii} from "../../interfaces/Yii";
import {IOperationArrayData} from './booking-quality-control-data.component';
import {EnumsResourceService} from "../../service/booking/enums/enums-resource.service";
import {IQualityCheckDictionary, IQualityCheckOperation} from "../../service/booking/IQualityCheck";
import {ESashaPermissions} from "libraries/enums/e-sasha-permissions";

@Component({
    selector: 'booking-quality-control-title',
    template: `
        <ng-container *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW">
            <ng-container *ngIf="controlList">
                {{controls.length > 1 ? wording.controls : wording.control}}:
                <strong>{{controlList}}</strong>
            </ng-container>
        </ng-container>
    `
})
export class BookingQualityControlTitleComponent implements OnInit {
    @Input()
    public booking: IGetBookingsCommonResponse;
    public sashaPermissions: typeof ESashaPermissions = ESashaPermissions;
    public controls: string[];
    public controlList: string;
    public controlsDictionnary: { [key: string]: string } = {};
    public wording: ILabels = {
        control: Yii.t('wui-sasha-js', 'Contrôle'),
        controls: Yii.t('wui-sasha-js', 'Contrôles')
    };

    constructor(
        private readonly enumsResourceService: EnumsResourceService,
        private readonly changeDetectorRef: ChangeDetectorRef) {
    }

    public ngOnInit(): void {
        this.initControlsDictionnary();
    }

    private initControlsDictionnary(): void {
        this.enumsResourceService.listQualityCheck()
            .subscribe((qualityCheckList: IQualityCheckDictionary): void => {
                qualityCheckList?.qualityCheckControlArray?.forEach((control: IQualityCheckOperation) => {
                    this.controlsDictionnary[control.code] = control?.nameArray?.length ? control.nameArray[0].value : control.code;
                });
                this.initControls();
                if(this.controls?.length){
                    this.controlList = this.controls.join(', ');
                    this.changeDetectorRef.detectChanges();
                }
            });
    }

    private initControls(): void {
        const controls: string[] = [];
        this.booking?.booking?.qualityCheck?.operationsLastPerformed?.operationArray?.forEach((operation: IOperationArrayData): void => {
            if (operation.control) {

                if (!controls.includes(operation.control) && !this.checkQualityCheckStatus(operation.status)) {
                    controls.push(operation.control);
                    this.controls = [...(this.controls || []), (this.controlsDictionnary[operation.control] ?? operation.control)];
                }
            }
        });
    }

    private checkQualityCheckStatus(bookingQualityCheckStatus: string): boolean {
        if (bookingQualityCheckStatus) {
            switch (bookingQualityCheckStatus.toLowerCase()) {
                case "success":
                case "no_action_required":
                case "action_performed":
                    return true;
                default:
                    return false;
            }
        }
    }
}
